// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xKasO","content":"styles_content__2o3PE"};